import { bind, classNames, Component, createRef, h, tag } from "omi";

import { NavCategoryTag } from "@/components/nw-nav/components/navCategoryTag";
import { formatCategory, isCourse, Topic } from "@/components/nw-nav/store/models";
import { useUserPreferencesMutation } from "@/components/nw-nav/store/mutations";
import { useCourses } from "@/components/nw-nav/store/queries/courses";
import { useSchedule } from "@/components/nw-nav/store/queries/schedule";
import { NavStore, NavView } from "@/components/nw-nav/store";
import { NWButton, NWIcon } from "@/components";
import { tailwind } from "@/tailwind";

import { useProjects } from "../../store/queries/project";

type Props = {};

@tag("nav-topic-list")
export class NavTopicList extends Component<Props> {
  static css = [tailwind];

  private tagContainerRef = createRef<HTMLDivElement>();
  private userPrefsMutation = useUserPreferencesMutation();

  private projects = useProjects();
  private courses = useCourses();

  @bind
  private handleHorizontalScroll(e: WheelEvent) {
    e.preventDefault();
    const div = this.tagContainerRef.current;
    if (div == null) {
      return;
    }

    const delta = e.deltaY || e.deltaX;
    div.scrollBy({ left: delta });
  }

  private handleBack() {
    NavStore.progressTo(NavView.CATEGORY_SELECTION);
  }

  private async handleRemoveTag(topic: Topic) {
    NavStore.selectTopic(topic);

    this.userPrefsMutation.mutate({ selectedCategories: NavStore.getSelectedTopicsAsCategories() });
    useSchedule().fetch({ topics: NavStore.getSelectedTopicsAsCategories() });
    import("@/services/analyticsService").then(({ useAnalyticsService }) => {
      useAnalyticsService().trackTimeSwitcherTopicChanged([topic.id]);
    });
  }

  render() {
    const isLoading =
      NavStore.selectedTopics.value.length === 0 &&
      (this.projects.projects.isLoading.value || this.courses.isLoading.value);

    return (
      <div class="flex items-center">
        <NWButton type="text" size="fit" class="w-fit mb-3 mr-1" onClick={this.handleBack}>
          <NWIcon name="chevron-down" class="rotate-90" width={12} height={12} />
        </NWButton>

        <div
          id="tagContainer"
          onWheel={this.handleHorizontalScroll}
          ref={this.tagContainerRef}
          class="relative pb-3 overflow-x-auto hide-scrollbar w-full"
        >
          {isLoading ? (
            <div class="animate-fadeInFast">
              <div class="animate-pulse">
                <div class="h-6 bg-gray-200 rounded-md w-full"></div>
              </div>
            </div>
          ) : (
            <div class="gap-2 flex h-6">
              {NavStore.selectedTopics.value.map(topic => (
                <NavCategoryTag onClick={() => this.handleRemoveTag(topic)}>
                  {isCourse(topic) ? topic.value.metadata?.title : formatCategory(topic.value)}
                </NavCategoryTag>
              ))}
              <div
                id="white-fade"
                style="background: linear-gradient(270deg, #FFF 40.63%, rgba(255, 255, 255, 0.00) 100%);"
                class={classNames(
                  "h-6 sticky -right-1 min-w-6 z-[51] pointer-events-none transition-opacity duration-150",
                )}
              ></div>
            </div>
          )}
        </div>
      </div>
    );
  }
}
